import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DropboxSquareFilledSvg from "@ant-design/icons-svg/es/asn/DropboxSquareFilled";
import AntdIcon from '../components/AntdIcon';
var DropboxSquareFilled = function DropboxSquareFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DropboxSquareFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DropboxSquareFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DropboxSquareFilled';
}
export default RefIcon;